"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertParamsToQueryString = void 0;
var convertSortToString = function (sort) { return Array.isArray(sort) ? sort.map(function (item) { return item.key + ":" + item.order; }) : sort.key + ":" + sort.order; };
var convertFiltersToString = function (filter) { return Array.isArray(filter) ? filter.map(function (item) { return item.key + "=" + item.value; }).join('&') : filter.key + "=" + filter.value; };
exports.convertParamsToQueryString = function (params) {
    if (params === void 0) { params = {}; }
    return Object.keys(params)
        .reduce(function (accumulator, cv, index, arr) {
        var queryString = "" + accumulator + (function () {
            if (cv === 'sort') {
                return cv + "=" + convertSortToString(params[cv]);
            }
            if (cv === 'filters') {
                return convertFiltersToString(params[cv]);
            }
            return cv + "=" + params[cv];
        })() + (index === arr.length - 1 ? '' : '&');
        return queryString;
    }, "" + (Object.keys(params).length > 0 ? '?' : ''));
};
